export const checkIfPathMatches = (pathname, destination) => {
  return destination === '/'
    ? pathname === destination
    : pathname.includes(destination);
};
